import type { Component, InjectionKey, Ref } from 'vue';
import type { DomRegistry } from './createDomRegistry';

/**
 * What a `SectionNavItem` may render as — anything `<component :is>` accepts. The
 * `keyof HTMLElementTagNameMap` arm gives tag-name autocomplete (`'div'`, `'section'`,
 * …); `(string & {})` keeps arbitrary strings (custom elements) valid without
 * collapsing the literal union; `Component` covers SFCs / functional components.
 */
export type SectionNavItemTag = keyof HTMLElementTagNameMap | (string & {}) | Component;

/**
 * The section-nav registry, provided by `SectionNavRoot` to its subtree. A
 * module-level key is enough: provide/inject isolates by component hierarchy, so
 * nested or sibling nav trees never collide. Type-erased to `unknown`; `T` is
 * re-pinned by `defineSectionNav<T>()` / `useSectionNav<T>()`.
 */
export const sectionNavRegistryKey = Symbol('nx-section-nav-registry') as InjectionKey<
  DomRegistry<unknown>
>;

/** The nearest `SectionNavItem`'s id, provided for descendants (e.g. a collapse toggle). */
export const sectionItemIdKey = Symbol('nx-section-nav-item-id') as InjectionKey<Ref<string>>;
